export default __webpack_public_path__ + "static/media/registrar-new-acount-background.0af0a689.png";